import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { PageCacheProvider } from './contexts/PageCacheContext';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Onboarding from './pages/Onboarding';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import EmailAccounts from './pages/EmailAccounts';
import MailTracking from './pages/MailTracking';
import TemplateSystem from './pages/TemplateSystem';
import Feedback from './pages/Feedback';
import EmailVerified from './pages/EmailVerified';
import VerifyEmail from './pages/VerifyEmail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Navbar from './components/Navbar';
import SubscriptionPage from './pages/SubscriptionPage';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentFail from './pages/PaymentFail';
import ComingSoon from './pages/ComingSoon';
import './App.css';

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Yükleniyor...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/auth/verify-email" element={<VerifyEmail />} />
        <Route path="/auth/email-verified" element={<EmailVerified />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/coming-soon" element={<ComingSoon />} />
        <Route path="/yakinda" element={<ComingSoon />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    );
  }

  // Check if user needs onboarding (email verified but onboarding not done)
  if (user.email_verified && !user.is_onboarding_done) {
    return <Onboarding />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <main className="container mx-auto px-4 py-8">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/email-accounts" element={<EmailAccounts />} />
          <Route path="/mail-tracking" element={<MailTracking />} />
          <Route path="/templates" element={<TemplateSystem />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/subscription" element={<SubscriptionPage />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/fail" element={<PaymentFail />} />
          <Route path="/coming-soon" element={<ComingSoon />} />
          <Route path="/yakinda" element={<ComingSoon />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <PageCacheProvider>
      <Router>
        <AppRoutes />
      </Router>
      </PageCacheProvider>
    </AuthProvider>
  );
}

export default App;